/**
 * Component: Scroll to Top
 * Description: 
 *
 * Usage:
 *   - Automatically initialises on page load.
 *
 * Notes:
 * 
 */

export function scrollToTop(elem) {
    if (!elem || !elem.length) return;

    function scrollToTop() {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth' // smooth scrolling
        });
    }

    elem.forEach((btn) => {
        btn.addEventListener('click', scrollToTop)
    });
}